var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.offers.length)?_c('special-info-box',{staticClass:"offers",scopedSlots:_vm._u([{key:"tag",fn:function(){return [_vm._v("Members only offers")]},proxy:true}],null,false,730393971)},[_vm._v(" "),_c('offers-list',{attrs:{"offers":_vm.offers}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }